module.exports = __webpack_public_path__ + "static/media/somewhat_intense.d0c519dd.svg";